import React from 'react';
import CommunityFeedPage from './CommunityFeedPage';

// ExplorePage is a wrapper that renders CommunityFeedPage
// Future: will add more tabs for web results, saved inspiration, etc.
const ExplorePage = () => {
  return <CommunityFeedPage />;
};

export default ExplorePage;
